import { useRef } from "react";
import PropTypes from "prop-types";
import { Button } from "antd";
import { CameraOutlined } from "@ant-design/icons";
import { useTranslation } from "react-i18next";
import EmployeeAvatar from "./EmployeeAvatar";

/** Avatar preview with a "Change photo" button, used on the add/edit employee page. */
function EmployeePhotoUpload({ preview, employee, onChange, error }) {
    const { t } = useTranslation("settings");
    const inputRef = useRef(null);

    return (
        <div className="flex flex-col items-center gap-3 text-center">
            <button
                type="button"
                onClick={() => inputRef.current?.click()}
                className={`group relative rounded-full ${error ? "ring-2 ring-red-400 ring-offset-2" : ""}`}
                aria-label={t("employees.changePhoto")}>
                <EmployeeAvatar employee={employee} src={preview || undefined} size={112} />
                <span className="absolute inset-0 flex items-center justify-center rounded-full bg-black/40 text-xl text-white opacity-0 transition-opacity group-hover:opacity-100">
                    <CameraOutlined />
                </span>
            </button>
            <Button shape="round" size="small" icon={<CameraOutlined />} onClick={() => inputRef.current?.click()}>
                {preview ? t("employees.changePhoto") : t("employees.uploadPhoto")}
            </Button>
            <p className="text-xs text-gray-400">{t("employees.photoHint")}</p>
            {error && <p className="text-xs text-red-500">{error}</p>}
            <input
                ref={inputRef}
                type="file"
                accept="image/*"
                hidden
                tabIndex={-1}
                aria-hidden="true"
                style={{ display: "none" }}
                onChange={onChange}
            />
        </div>
    );
}

EmployeePhotoUpload.propTypes = {
    preview: PropTypes.string,
    employee: PropTypes.object,
    onChange: PropTypes.func.isRequired,
    error: PropTypes.string,
};

export default EmployeePhotoUpload;
